<template>
  <div>
    <div class="accordion-trigger" @click="open=!open" role="button" tabindex="0">
        <header class="accordion" :class="{active:open}" ><p>{{ title }}</p></header>
    </div>
    <transition :name="animation">
        <div class="panel" v-show="open">
            <slot></slot>
        </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'accordion',

    data() {
      return {
        open: false
      }
    },

    props: {
      title: {
        type: String,
        default: 'title'
      },
      animation: {
        type: String,
        default: 'reveal'
      }
    }
  }
</script>

<style scoped lang="scss">
.reveal-enter-active, .reveal-leave-active {
  transition: all .3s ease;
}

.reveal-enter, .reveal-leave-to {
  opacity: 0;
}

section {
  max-width: 679px;
  margin: 0 auto;
}

.help-intro {
  margin-top: 60px;
}

.help-intro h1 {
  font-family: 'noto-serif-condensed', 'Times New Roman', Times, serif;
  font-size: 2em;
  font-weight: 300;
  line-height: 1.344;
  color: #000;
}

.help-outro p {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 1em;
  line-height: 1.5;
  color: #333;
  margin-bottom: 28px;
}

.help-outro a.nav-link {
  font-size: 1.0625em;
  font-weight: 700;
  color:  #000;
  text-transform: uppercase;
}

.accordion-trigger {
  cursor: pointer;
}

.accordion {
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  border-top: 2px solid #010101;
  padding: 5px 0;
  position: relative;
  z-index: -1;
}

.accordion p {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: .8125em;
  line-height: 1.308;
  color:  #333;
  max-width: 80%;
}

.accordion:before {
  content: '\02795';
  font-size: 1em;
  color: #333;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.accordion.active:before {
  content: "\2796";
}

.panel {
  overflow: hidden;
}

.panel p, ol, table {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: .8125em;
  line-height: 1.308;
  color:  #000;
  max-width: 90%;
}

.panel p:last-of-type {
  padding-bottom: 20px;
}

.panel ol {
  padding-left: 16px;
  padding-bottom: 10px;
}

.panel li {
  margin-bottom: 10px;
}

table {
  border: 1px solid #000;
  max-width: 100%;
  width: 100%;
  border-collapse:separate; 
  border-spacing:0 5px;
  margin-bottom: 20px;
}

thead tr th{
  border-bottom: 1px solid #000;
  padding: 5px;
}

td {
  width: 33%;
  padding: 5px;
}

.center {
  text-align: center;
}

@media only screen and (min-width:500px) {
  .help-intro h1 {
    margin-bottom: 50px;
  }

  .accordion p {
    font-size: .9375em;
    line-height: 1.266;
  }

  .accordion:before {
    font-size: 1.2em;
  }

  .panel p, ol, table {
    font-size: .875em;
  }
}
</style>
